import { render, staticRenderFns } from "./Clients.vue?vue&type=template&id=23d96ff2&scoped=true"
import script from "./Clients.vue?vue&type=script&lang=js"
export * from "./Clients.vue?vue&type=script&lang=js"
import style0 from "./Clients.vue?vue&type=style&index=0&id=23d96ff2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23d96ff2",
  null
  
)

export default component.exports